export const globalMixin = {
  computed: {
    isMobile() {
      return document.body.classList.contains('mobile');
    },
  },
  mounted() {
    if (this.breadcrumbs) {
      this.$store.commit('breadcrumbs/SET', this.breadcrumbs);
    }
  },
};
